<template>
  <v-content>
    <div class="bg-image"></div>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="5">
          <ValidateAll ref="form" v-slot="{ invalid }" tag="form" @submit.prevent="login()">
            <v-card class="elevation-12">
              <v-row no-gutters>
                <v-col cols="12" md="4" class="flex-grow-1 flex-shrink-0 logo"></v-col>
                <v-col cols="12" md="8" class="flex-grow-1 flex-shrink-0">
                  <v-card-title>
                    <v-icon color="success" left>mdi-lock</v-icon>KLIK BOS
                  </v-card-title>
                  <v-card-subtitle>Silahkan lengakapi form dibawah ini untuk mengakses aplikasi</v-card-subtitle>
                  <v-card-text>
                    <Validate name="Username" rules="required" #default="{ errors }">
                      <v-text-field
                        v-model="username"
                        label="Username"
                        placeholder="Username"
                        name="login"
                        type="text"
                        class="mb-3"
                        hide-details="auto"
                        :error-messages="errors"
                        outlined
                      ></v-text-field>
                    </Validate>
                    <Validate name="Password" rules="required" #default="{ errors }">
                      <v-text-field
                        v-model="password"
                        id="password"
                        label="Password"
                        placeholder="Password"
                        name="password"
                        type="password"
                        class="mb-3"
                        hide-details="auto"
                        :error-messages="errors"
                        outlined
                      ></v-text-field>
                    </Validate>
                    <v-btn :loading="loading" @click="login" :disabled="invalid">
                      <v-icon left>mdi-login</v-icon>Masuk
                    </v-btn>
                    <div
                      class="caption mt-4 grey--text"
                    >Inspektorat Daerah &mdash; Kota Bontang &mdash; Development Version</div>
                  </v-card-text>
                </v-col>
              </v-row>
            </v-card>
          </ValidateAll>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>

<script>
import { mapState } from "vuex";
import logo from "@/assets/logo.jpg";
// import axios from '@/plugins/axios';
export default {
  data() {
    return {
      logo,
      loading: false,
      username: "",
      password: ""
    };
  },
  computed: {
    ...mapState({
      app: state => state.app
    })
  },
  beforeCreate() {
    var dark = localStorage.getItem("dark");
    this.$vuetify.theme.dark = dark ? dark == "true" : false;
  },
  created() {
    // if (this.$session.get.token() != null) {
    //   this.$router.push("/");
    // }
    this.username = "";
    this.password = "";
  },
  methods: {
    async login() {
      const valid = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;
      this.axios
        .post("auth", { username: this.username, password: this.password })
        .then(res => {
          let data = res.data.Data;
          if (data.Group) data.Group = data.Group.Name;
          this.$session.store(data);
          this.loading = false;
          this.$acl.change(data.GroupID);
          this.$router.push("/");
        })
        .catch(err => {
          this.$dialog.notify.error(err, {
            ...this.app.notification
          });
          this.loading = false;
        });
    }
  }
};
</script>

<style scope>
.logo {
  background: url("../../assets/logo.jpg") no-repeat center center;
  background-size: 80%;
  border-right: solid thin #ddd;
}
.bg-image {
  background: url("../../assets/bg.jpg") no-repeat center center;
  background-size: cover;
  filter: blur(8px);
  -webkit-filter: blur(8px);
  position: absolute;
  width: 100%;
  height: 100%;
}
</style>
